import { useState } from 'react'

import { Pagination } from '@components/shared/Table/components/Pagination'

import type { WeekRelationSectionProps } from './types'

import * as ListStyles from '../../UnitsListModal/styles'
import * as S from './styles'

const DEFAULT_ITEMS_PER_PAGE = 10

export const WeekRelationSection = ({
  section,
  cardTitle
}: {
  section: WeekRelationSectionProps
  cardTitle: string
}) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE)

  const totalItems = section.units.length
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage))
  const pagedUnits = section.units.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)

  return (
    <S.SectionWrapper>
      <ListStyles.TabBadge color={section.color} background={section.background}>
        <ListStyles.Dot color={section.color} />
        {section.label}
        <ListStyles.StatusCountBadge color={section.color}>{section.count}</ListStyles.StatusCountBadge>
      </ListStyles.TabBadge>

      <ListStyles.DashedCard>
        <ListStyles.Card>
          <ListStyles.CardHeader>
            <ListStyles.IconWrapper color={section.color}>{section.icon}</ListStyles.IconWrapper>
            {cardTitle}
          </ListStyles.CardHeader>

          <ListStyles.UnitList>
            {pagedUnits.map((unit, index) => (
              <ListStyles.UnitRow key={`${unit}-${index}`}>{unit}</ListStyles.UnitRow>
            ))}
          </ListStyles.UnitList>

          <ListStyles.Footer>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
              onPageChange={setCurrentPage}
              onItemsPerPageChange={(value) => {
                setItemsPerPage(value)
                setCurrentPage(1)
              }}
            />
          </ListStyles.Footer>
        </ListStyles.Card>
      </ListStyles.DashedCard>
    </S.SectionWrapper>
  )
}
